<template>
  <v-dialog
    v-model="dialog"
    max-width="400px"
    scrollable>
    <template v-slot:activator="{ on, attrs }">
      <a
        v-bind="attrs"
        v-on="on">
        {{ $t('connector.website.btn.createMethod') }}
      </a>
    </template>
    <v-card
      class="app-card"
      tile>
      <v-card-title>
        <title-label :label="$t('connector.website.dialog.createMethodTitle')" />
        <v-spacer />
        <v-btn
          icon
          small
          @click="closeDialog()">
          <v-icon small>
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        1. {{ $t('connector.website.dialog.createMethodNo1') }}<br /><br />
        2. {{ $t('connector.website.dialog.createMethodNo2') }}<br /><br />
        3. {{ $t('connector.website.dialog.createMethodNo3') }}
      </v-card-text>
      <v-card-actions class="connector_dialog--action">
        <v-spacer />
        <v-btn
          color="primary"
          depressed
          rounded
          @click="closeDialog()">
          {{ $t('app.btn.acknowledged') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  data () {
    return {
      dialog: false
    }
  },
  methods: {
    closeDialog () {
      this.dialog = false
    }
  }
}
</script>

<style>

</style>

<style scoped>

</style>
